
var settlementPdf = require('./settlement-pdf.js');
var jpegToPdf = settlementPdf.jpegToPdf;
var PDF_MIN_WIDTH = 1336;
var PDF_A4_RATIO = settlementPdf.a4LandscapeRatio();

var AH = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
var IJK_KEYS = ['b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k'];
var RESERVED_CODES = {
  A: 1, B: 1, C: 1, D: 1, E: 1, F: 1, G: 1, H: 1, I: 1, J: 1, K: 1,
  owner_income: 1, income: 1, stay_tax: 1
};
var DEFAULT_LABEL = {
  A: 'A総売上',
  B: 'Bサイト手数料',
  C: 'C弊社報酬',
  D: 'D清掃費',
  E: 'Eアメニティ',
  F: 'F消耗品',
  G: 'Gクリーニング',
  H: 'Hウエルカムシャンパン',
  I: 'Iサイトコントローラー',
  J: 'Jゴミ収集',
  K: 'K使用人'
};
var DECOR_LABEL = {
  A: 'A総売上',
  B: 'Bサイト手数料（A〇％）',
  C: 'C弊社報酬（A〇％）',
  D: 'D清掃費',
  E: 'Eアメニティ',
  F: 'F消耗品　〇〇〇円*人数*日数',
  G: 'Gクリーニング　〇〇〇円*人数',
  H: 'Hウエルカムシャンパン'
};
var FEE_LABEL = {
  I: 'サイト\nコントローラー',
  J: 'ゴミ収集',
  K: '使用人'
};
var TAX_HEADS = [
  '三棟経費', 'Bサイト手数料', 'C弊社報酬', 'D清掃費', 'Eアメニティ', 'F消耗品',
  'Gクリーニング', 'Hシャンパン', 'Iサイトコント\nローラー', 'Jゴミ収集', 'K使用人', 'C-K\n課税取引計'
];
var STAY_COLS = [
  { key: 'checkin', label: 'チェックイン', w: 96 },
  { key: 'checkout', label: 'チェックアウト', w: 96 },
  { key: 'days', label: '日数', w: 48 },
  { key: 'guests', label: '人数', w: 48 },
  { key: 'income', label: '収入額', w: 80 },
  { key: 'tax', label: '宿泊税', w: 80 },
  { key: 'A', code: 'A', label: 'A総売上', w: 80 },
  { key: 'B', code: 'B', label: 'Bサイト手数料\n（A〇％）', w: 96 },
  { key: 'C', code: 'C', label: 'C弊社報酬\n（A〇％）', w: 80 },
  { key: 'D', code: 'D', label: 'D清掃費', w: 80 },
  { key: 'E', code: 'E', label: 'Eアメニティ', w: 80 },
  { key: 'F', code: 'F', label: 'F消耗品\n〇〇〇円*人数*日数', w: 104 },
  { key: 'G', code: 'G', label: 'Gクリーニング\n〇〇〇円*人数', w: 104 },
  { key: 'H', code: 'H', label: 'Hウエルカム\nシャンパン', w: 104 },
  { key: 'ownerIncome', label: 'オーナー収入', w: 104 }
];

function columnLabelOf(by, code, fallback) {
  var it = by[code];
  if (it && it.label && it.label !== DEFAULT_LABEL[code]) return it.label;
  return fallback || (it && it.label) || code;
}

function canvasToJpegPdf(canvas, cssW, cssH) {
  return new Promise(function (resolve, reject) {
    if (!canvas || !canvas.width || !canvas.height) {
      reject(new Error('empty'));
      return;
    }
    canvas.toBlob(function (blob) {
      if (!blob) {
        reject(new Error('jpeg'));
        return;
      }
      var reader = new FileReader();
      reader.onload = function () {
        var jpeg = new Uint8Array(reader.result);
        resolve(jpegToPdf(jpeg, Math.max(1, cssW), Math.max(1, cssH), canvas.width, canvas.height));
      };
      reader.onerror = function () {
        reject(new Error('read'));
      };
      reader.readAsArrayBuffer(blob);
    }, 'image/jpeg', 0.92);
  });
}

function gridColumnCount(el) {
  var style = window.getComputedStyle(el);
  var template = (style && style.gridTemplateColumns) || '';
  if (!template || template === 'none') return 0;
  var parts = template.trim().split(/\s+/);
  var count = 0;
  var i;
  for (i = 0; i < parts.length; i++) {
    if (parts[i] && parts[i] !== '/') count++;
  }
  return count;
}

function flattenGrid(el, cols) {
  if (!el || !el.parentNode || cols < 1) return;
  var cells = [];
  var child = el.firstElementChild;
  while (child) {
    cells.push(child);
    child = child.nextElementSibling;
  }
  if (!cells.length) return;
  var table = document.createElement('table');
  table.setAttribute('cellspacing', '0');
  table.style.cssText = 'width:100%;border-collapse:separate;border-spacing:4px;table-layout:fixed;background:transparent;';
  var row = null;
  var i;
  for (i = 0; i < cells.length; i++) {
    if (i % cols === 0) {
      row = document.createElement('tr');
      table.appendChild(row);
    }
    var cell = cells[i];
    var tall = cell.classList && (cell.classList.contains('is-head') || cell.classList.contains('is-tall'));
    var td = document.createElement('td');
    td.textContent = cell.innerText || '';
    td.style.cssText = 'box-sizing:border-box;border:1px solid #b8cad1;background:#fff;text-align:center;vertical-align:middle;font-size:10px;font-weight:700;line-height:12px;color:#341717;height:' + (tall ? '36px' : '24px') + ';padding:0 2px;overflow:hidden;white-space:pre-line;';
    row.appendChild(td);
  }
  el.parentNode.replaceChild(table, el);
}

function flattenBankRows(root) {
  var rows = root.querySelectorAll('.owner-settlement-bank__row');
  var i;
  for (i = 0; i < rows.length; i++) {
    var row = rows[i];
    var spans = row.querySelectorAll('span');
    if (spans.length < 2) continue;
    var tall = row.classList && row.classList.contains('is-tall');
    var table = document.createElement('table');
    table.style.cssText = 'width:100%;border-collapse:separate;border-spacing:0;table-layout:fixed;margin:0 0 4px;';
    var tr = document.createElement('tr');
    var label = document.createElement('td');
    var value = document.createElement('td');
    label.textContent = spans[0].innerText || '';
    value.textContent = spans[1].innerText || '';
    label.style.cssText = 'width:31%;height:' + (tall ? '36px' : '24px') + ';border:1px solid #b8cad1;background:#b8cad1;text-align:center;vertical-align:middle;font-size:10px;font-weight:700;color:#341717;';
    value.style.cssText = 'width:69%;height:' + (tall ? '36px' : '24px') + ';border:1px solid #b8cad1;background:#fff;text-align:center;vertical-align:middle;font-size:10px;font-weight:700;color:#341717;white-space:pre-line;';
    tr.appendChild(label);
    tr.appendChild(value);
    table.appendChild(tr);
    row.parentNode.replaceChild(table, row);
  }
}

function flattenPdfGrids(root) {
  var stays = root.querySelectorAll('.owner-stay-grid');
  var taxes = root.querySelectorAll('.owner-tax-grid');
  var sums = root.querySelectorAll('.owner-settle-summary');
  var i;
  for (i = 0; i < stays.length; i++) flattenGrid(stays[i], gridColumnCount(stays[i]));
  for (i = 0; i < taxes.length; i++) flattenGrid(taxes[i], 12);
  for (i = 0; i < sums.length; i++) flattenGrid(sums[i], 4);
  flattenBankRows(root);
}

function mountPdfSheet(source) {
  var width = Math.max(source.offsetWidth || 0, PDF_MIN_WIDTH);
  var minHeight = Math.ceil(width / PDF_A4_RATIO);
  var host = document.createElement('div');
  host.setAttribute('aria-hidden', 'true');
  host.style.cssText = 'position:fixed;left:0;top:0;width:' + width + 'px;z-index:-1;pointer-events:none;background:#e6e6e5;';
  var clone = source.cloneNode(true);
  clone.style.width = width + 'px';
  clone.style.minWidth = width + 'px';
  clone.style.minHeight = minHeight + 'px';
  clone.style.maxWidth = 'none';
  clone.style.backgroundColor = '#e6e6e5';
  var arrows = clone.querySelectorAll('.owner-settle-arrow');
  var i;
  for (i = 0; i < arrows.length; i++) arrows[i].style.visibility = 'hidden';
  host.appendChild(clone);
  document.body.appendChild(host);
  clone.getBoundingClientRect();
  flattenPdfGrids(clone);
  return {
    host: host,
    node: clone,
    width: clone.offsetWidth,
    height: clone.offsetHeight
  };
}

function savePdfBytes(bytes, name) {
  var blob = new Blob([bytes], { type: 'application/pdf' });
  var objectUrl = window.URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = objectUrl;
  a.download = name;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(function () {
    window.URL.revokeObjectURL(objectUrl);
  }, 1000);
}

export default {
  name: 'owner-settlement',
  data: function () {
    var now = new Date();
    var q = (this.$route && this.$route.query) || {};
    var y = parseInt(q.year, 10);
    var m = parseInt(q.month, 10);
    if (!y) y = now.getFullYear();
    if (!m || m < 1 || m > 12) m = now.getMonth() + 1;
    return {
      year: y,
      month: m,
      published: false,
      rows: [],
      yearRows: [],
      meta: this.blankMeta(y, m),
      ijk: this.blankIjk(),
      loadSeq: 0,
      annualCache: null,
      rowsStamp: '',
      publishedList: [],
      pickedMonths: [],
      skipLoad: 0,
      items: [],
      mockHold: false,
      transferRow: null,
      pdfBusy: false
    };
  },
  computed: {
    yearOptions: function () {
      var now = new Date().getFullYear();
      var start = Math.min(now - 2, 2025);
      var end = Math.max(now + 1, 2026);
      if (this.year < start) start = this.year;
      if (this.year > end) end = this.year;
      var years = [];
      for (var y = start; y <= end; y++) years.push(y);
      return years;
    },
    ahColumns: function () {
      var by = this.itemsByCode();
      return AH.map(function (code) {
        return { code: code, label: columnLabelOf(by, code, DECOR_LABEL[code] || code) };
      });
    },
    extraColumns: function () {
      return (this.items || []).filter(function (it) {
        return it && it.code && !RESERVED_CODES[it.code] && it.visible !== 0 && it.visible !== false;
      }).slice().sort(function (a, b) {
        return (Number(a.sort) || 0) - (Number(b.sort) || 0);
      });
    },
    stayColspan: function () {
      return 7 + this.ahColumns.length;
    },
    roomSummaryColumns: function () {
      var by = this.itemsByCode();
      var fixed = [
        { code: 'I', label: columnLabelOf(by, 'I', 'サイトコントローラー') },
        { code: 'J', label: columnLabelOf(by, 'J', 'ゴミ収集') },
        { code: 'K', label: columnLabelOf(by, 'K', '使用人') }
      ];
      return fixed.concat(this.extraColumns);
    },
    adrRows: function () {
      var t = this;
      var mi = (Number(this.month) || 1) - 1;
      var list = this.yearRows || [];
      if (!list.length) list = this.rows || [];
      return list.map(function (room) {
        var cell = room.months && room.months[mi] ? room.months[mi] : null;
        var amt = room.amounts || {};
        return {
          id: room.id,
          name: room.name,
          profit: cell ? cell.profit : t.formatCell(amt.owner_income),
          adr: cell ? cell.adr : t.formatCell(amt.adr),
          occ: cell ? cell.occ : t.formatCell(amt.occupancy, 'occ')
        };
      });
    },
    summaryRows: function () {
      var rows = this.adrRows || [];
      if (this.transferRow) return rows.concat([this.transferRow]);
      return rows;
    },
    periodLabel: function () {
      if (this.mockHold && this.meta && this.meta.period) return this.meta.period;
      return this.year + '年' + this.month + '月';
    },
    summaryMonthLabel: function () {
      if (this.mockHold) return '6月';
      return this.month + '月';
    },
    bankNameValue: function () {
      var name = this.displayValue(this.meta.accountName);
      if (!this.meta.accountId) return name;
      return name + '\n' + this.meta.accountId;
    },
    stayColumns: function () {
      var by = this.itemsByCode();
      var cols = STAY_COLS.map(function (col) {
        var label = col.label;
        if (col.code && by[col.code] && by[col.code].label && by[col.code].label !== DEFAULT_LABEL[col.code]) {
          label = by[col.code].label;
        }
        return { key: col.key, code: col.code, label: label, w: col.w };
      });
      var extras = this.extraColumns.map(function (it) {
        return { key: it.code, code: it.code, label: it.label || it.code, w: 80 };
      });
      if (!extras.length) return cols;
      var last = cols.pop();
      return cols.concat(extras).concat([last]);
    },
    stayGridStyle: function () {
      return {
        gridTemplateColumns: this.stayColumns.map(function (col) {
          return 'minmax(0, ' + col.w + 'fr)';
        }).join(' ')
      };
    },
    taxHeads: function () {
      return TAX_HEADS;
    },
    taxRows: function () {
      var ijk = this.ijk || {};
      var keys = ['b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'taxed'];
      if (this.mockHold) {
        var mark = keys.map(function () { return '〇'; });
        return [
          { label: '税込金額', cells: mark },
          { label: '税抜金額', cells: mark.slice() },
          { label: '税率10％', cells: mark.slice() }
        ];
      }
      var included = keys.map(function (k) {
        return ijk[k] == null ? '' : ijk[k];
      });
      var excl = keys.map(function () { return ''; });
      excl[excl.length - 1] = ijk.taxOut == null ? '' : ijk.taxOut;
      var rateCells = keys.map(function () { return ''; });
      rateCells[rateCells.length - 1] = ijk.taxRate == null ? '' : ijk.taxRate;
      var rateText = ijk.taxRate == null || ijk.taxRate === '' || ijk.taxRate === 0 ? '10％' : String(ijk.taxRate);
      if (rateText.indexOf('％') < 0) rateText += '％';
      return [
        { label: '税込金額', cells: included },
        { label: '税抜金額', cells: excl },
        { label: '税率' + rateText, cells: rateCells }
      ];
    }
  },
  watch: {
    year: function () {
      if (this.skipLoad > 0) {
        this.skipLoad -= 1;
        return;
      }
      this.pickedMonths = [];
      this.load();
    },
    month: function () {
      if (this.skipLoad > 0) {
        this.skipLoad -= 1;
        return;
      }
      this.load();
    },
    '$route.query': function (q) {
      q = q || {};
      var y = parseInt(q.year, 10);
      var m = parseInt(q.month, 10);
      if (isFinite(y) && y > 0 && y !== this.year) {
        this.year = y;
      }
      if (isFinite(m) && m >= 1 && m <= 12 && m !== this.month) {
        this.month = m;
      }
    }
  },
  created: function () {
    this.$eventBus.$on('owner-mock-settlement-data', this.applyMockSheet);
    this.$eventBus.$on('owner-mock-settlement-empty', this.clearMockSheet);
    this.loadProfile();
    this.load();
  },
  beforeDestroy: function () {
    this.$eventBus.$off('owner-mock-settlement-data', this.applyMockSheet);
    this.$eventBus.$off('owner-mock-settlement-empty', this.clearMockSheet);
  },
  methods: {
    blankMeta: function (year, month) {
      return {
        guestName: '',
        period: year + '年' + month + '月',
        title: '精算金計算書',
        contractRate: '',
        reportNote: '',
        bankName: '',
        bankBranch: '',
        accountType: '',
        accountNo: '',
        accountName: '',
        accountId: '',
        comment: '',
        company: '',
        companyZip: '',
        companyReg: '',
        companyAddress: ''
      };
    },
    loadProfile: function () {
      var t = this;
      axios.get('landlord/me').then(function (res) {
        var item = res.data && res.data.options && res.data.options.item;
        if (res.data && res.data.status == 1 && item && !t.meta.guestName) {
          t.meta.guestName = item.name || ((item.lastname || '') + (item.firstname || ''));
        }
      }).catch(function () {});
    },
    goBack: function () {
      this.$router.push('/owner');
    },
    displayValue: function (value) {
      return value === null || value === undefined || value === '' ? '未登録' : value;
    },
    blankIjk: function () {
      return {
        b: 0, c: 0, d: 0, e: 0, f: 0, g: 0, h: 0,
        i: 0, j: 0, k: 0, taxed: 0, taxIn: 0, taxOut: 0, taxRate: 0
      };
    },
    emptyMonths: function () {
      var list = [];
      for (var i = 0; i < 12; i++) {
        list.push({ profit: '—', adr: '—', occ: '—' });
      }
      return list;
    },
    yen: function (n) {
      if (n === null || n === undefined || n === '') return '';
      var v = Number(n);
      if (!isFinite(v)) return String(n);
      return v.toLocaleString('ja-JP');
    },
    stayNum: function (stay, upper, lower) {
      if (!stay) return '';
      if (stay[upper] !== undefined && stay[upper] !== null) return stay[upper];
      if (stay[lower] !== undefined && stay[lower] !== null) return stay[lower];
      return '';
    },
    itemsByCode: function () {
      var by = {};
      (this.items || []).forEach(function (it) {
        if (it && it.code) by[it.code] = it;
      });
      return by;
    },
    columnLabel: function (code, fallback) {
      return columnLabelOf(this.itemsByCode(), code, fallback);
    },
    staySpan: function (room) {
      var n = room && room.stays ? room.stays.length : 0;
      return n > 0 ? n : 1;
    },
    roomExtra: function (room, code) {
      return this.roomAmount(room, code);
    },
    feeCell: function (fee, index) {
      if (index === 0) return fee.label;
      if (index === this.stayColumns.length - 1) return fee.value;
      return '';
    },
    roomFees: function (room) {
      var t = this;
      return this.roomSummaryColumns.map(function (col) {
        return {
          label: FEE_LABEL[col.code] || col.label,
          value: t.roomAmount(room, col.code),
          tall: col.code === 'I'
        };
      });
    },
    roomAmount: function (room, code) {
      if (room && room.feeDisplay && room.feeDisplay[code] != null && room.feeDisplay[code] !== '') {
        return room.feeDisplay[code];
      }
      var amt = room && room.amounts ? room.amounts : {};
      var raw = amt[code];
      if (raw === undefined || raw === null || raw === '') {
        raw = amt[String(code).toLowerCase()];
      }
      if (raw === undefined || raw === null || raw === '') return '';
      return this.yen(raw);
    },
    mapStay: function (stay) {
      stay = stay || {};
      var row = {
        checkin: stay.checkin || '',
        checkout: stay.checkout || '',
        days: stay.nights,
        guests: stay.guest_count,
        income: this.yen(stay.income),
        tax: this.yen(stay.stay_tax),
        ownerIncome: this.yen(stay.owner_income)
      };
      var t = this;
      var skip = {
        order_id: 1, checkin: 1, checkout: 1, nights: 1, guest_count: 1,
        income: 1, stay_tax: 1, hidden: 1, owner_income: 1
      };
      Object.keys(stay).forEach(function (key) {
        if (skip[key]) return;
        row[key] = t.yen(stay[key]);
      });
      return row;
    },
    amtNum: function (amt, upper, lower) {
      if (!amt) return 0;
      if (amt[upper] !== undefined && amt[upper] !== null && amt[upper] !== '') {
        return Number(amt[upper]) || 0;
      }
      if (amt[lower] !== undefined && amt[lower] !== null && amt[lower] !== '') {
        return Number(amt[lower]) || 0;
      }
      return 0;
    },
    sumIjk: function (rooms) {
      var ijk = this.blankIjk();
      var taxOut = 0;
      var taxIn = 0;
      var taxRate = 0;
      var t = this;
      (rooms || []).forEach(function (room) {
        var amt = room.amounts || {};
        IJK_KEYS.forEach(function (k) {
          ijk[k] += t.amtNum(amt, k.toUpperCase(), k);
        });
        taxOut += t.amtNum(amt, 'tax_excl', 'taxExcl');
        taxIn += t.amtNum(amt, 'tax_incl', 'taxIncl');
        if (!taxRate && amt.tax_rate) taxRate = Number(amt.tax_rate) || 0;
      });
      ijk.taxed = ijk.c + ijk.d + ijk.e + ijk.f + ijk.g + ijk.h + ijk.i + ijk.j + ijk.k;
      ijk.taxOut = taxOut;
      ijk.taxIn = taxIn;
      ijk.taxRate = taxRate || 10;
      var out = {};
      ['b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'taxed', 'taxIn', 'taxOut'].forEach(function (k) {
        out[k] = t.yen(ijk[k]);
      });
      out.taxRate = ijk.taxRate + '％';
      return out;
    },
    formatOcc: function (n) {
      if (n === null || n === undefined || n === '') return '—';
      var v = Number(n);
      if (!isFinite(v)) return '—';
      if (v <= 1) v = v * 100;
      if (v === 100) return '100％';
      var r = Math.round(v * 100) / 100;
      if (r === Math.round(r)) return r + '％';
      return r.toFixed(2) + '％';
    },
    formatCell: function (v, kind) {
      if (v === null || v === undefined || v === '') return '—';
      if (kind === 'occ') return this.formatOcc(v);
      return this.yen(v);
    },
    applyPublished: function (opt) {
      var t = this;
      var s = opt.settlement || {};
      var landlord = opt.landlord || {};
      var rooms = opt.rooms || [];
      this.published = true;
      this.items = Array.isArray(opt.items) ? opt.items : [];
      this.meta.guestName = landlord.name || '';
      this.meta.period = (s.year || this.year) + '年' + (s.month || this.month) + '月';
      this.meta.comment = s.comment == null ? '' : s.comment;
      this.meta.bankName = s.bank_name || '';
      this.meta.bankBranch = s.bank_branch || '';
      this.meta.accountType = s.bank_account_type || landlord.bank_account_type || '';
      this.meta.accountNo = s.bank_account_no || '';
      this.meta.accountName = s.bank_account_name || '';
      this.meta.accountId = s.invoice_reg_no || '';
      this.ijk = this.sumIjk(rooms);
      this.rowsStamp = this.year + '-' + this.month;
      this.rows = rooms.map(function (room) {
        var stays = Array.isArray(room.stays) ? room.stays : [];
        return {
          id: room.room_id,
          name: room.room_name,
          amounts: room.amounts || {},
          stays: stays.filter(function (stay) {
            return !(stay && (stay.hidden === 1 || stay.hidden === true));
          }).map(function (stay) {
            return t.mapStay(stay);
          })
        };
      });
      if (this.annualCache) this.applyAnnual(this.annualCache);
      else this.overlayYearFromMonth();
    },
    overlayYearFromMonth: function () {
      var t = this;
      if (this.rowsStamp !== (this.year + '-' + this.month)) return;
      var mi = (this.month || 1) - 1;
      if (mi < 0 || mi > 11) return;
      (this.rows || []).forEach(function (row) {
        if (!row) return;
        var amt = row.amounts || {};
        var target = null;
        for (var i = 0; i < t.yearRows.length; i++) {
          if (t.yearRows[i].id === row.id) {
            target = t.yearRows[i];
            break;
          }
        }
        if (!target) {
          target = { id: row.id, name: row.name, months: t.emptyMonths() };
          t.yearRows.push(target);
        }
        var months = target.months.slice();
        months[mi] = {
          profit: t.formatCell(amt.owner_income),
          adr: t.formatCell(amt.adr),
          occ: t.formatCell(amt.occupancy, 'occ')
        };
        t.$set(target, 'months', months);
      });
    },
    applyAnnual: function (opt) {
      this.annualCache = opt || null;
      if (!opt || !opt.rooms) {
        this.overlayYearFromMonth();
        return;
      }
      var t = this;
      this.yearRows = (opt.rooms || []).map(function (room) {
        var cells = room.months || [];
        var months = t.emptyMonths();
        for (var i = 0; i < 12; i++) {
          var cell = cells[i] || {};
          months[i] = {
            profit: t.formatCell(cell.profit),
            adr: t.formatCell(cell.adr),
            occ: t.formatCell(cell.occupancy, 'occ')
          };
        }
        return {
          id: room.room_id,
          name: room.room_name,
          months: months
        };
      });
      this.overlayYearFromMonth();
    },
    sortedPublished: function () {
      return (this.publishedList || []).slice().sort(function (a, b) {
        if (a.year !== b.year) return a.year - b.year;
        return a.month - b.month;
      });
    },
    isPublishedMonth: function (month) {
      var y = Number(this.year);
      var m = Number(month);
      var i;
      var item;
      for (i = 0; i < this.publishedList.length; i++) {
        item = this.publishedList[i];
        if (Number(item.year) === y && Number(item.month) === m) return true;
      }
      return false;
    },
    setPeriod: function (year, month) {
      var y = Number(year);
      var m = Number(month);
      var changes = 0;
      if (Number(this.year) !== y) {
        this.pickedMonths = [];
        changes += 1;
      }
      if (Number(this.month) !== m) changes += 1;
      this.skipLoad = changes;
      this.year = y;
      this.month = m;
      if (!changes) return;
      this.load();
    },
    shiftPublished: function (delta) {
      var list = this.sortedPublished();
      if (!list.length) {
        this.toast('まだ公開されていません');
        return;
      }
      var y = Number(this.year);
      var m = Number(this.month);
      var i;
      var exact = -1;
      var next = null;
      for (i = 0; i < list.length; i++) {
        if (Number(list[i].year) === y && Number(list[i].month) === m) {
          exact = i;
          break;
        }
      }
      if (exact >= 0) {
        next = list[exact + delta] || null;
      } else if (delta > 0) {
        for (i = 0; i < list.length; i++) {
          if (Number(list[i].year) > y || (Number(list[i].year) === y && Number(list[i].month) > m)) {
            next = list[i];
            break;
          }
        }
      } else {
        for (i = list.length - 1; i >= 0; i--) {
          if (Number(list[i].year) < y || (Number(list[i].year) === y && Number(list[i].month) < m)) {
            next = list[i];
            break;
          }
        }
      }
      if (!next) return;
      this.setPeriod(next.year, next.month);
    },
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    loadPublished: function () {
      var t = this;
      var seq = this.loadSeq;
      axios.get('landlord/settlement/publishedMonths').then(function (res) {
        if (seq !== t.loadSeq) return;
        var items = [];
        if (res.data && res.data.status == 1 && res.data.options && res.data.options.items) {
          items = res.data.options.items;
        }
        t.publishedList = items.map(function (item) {
          return { year: Number(item.year), month: Number(item.month) };
        });
      }).catch(function () {});
    },
    downloadBlob: function (url, params, kind) {
      var t = this;
      axios.get(url, { params: params, responseType: 'blob' }).then(function (res) {
        var blob = res.data;
        var ctype = '';
        if (res.headers) {
          ctype = res.headers['content-type'] || res.headers['Content-Type'] || '';
        }
        if (!ctype && blob && blob.type) ctype = blob.type;
        if (ctype.indexOf('application/json') !== -1 || ctype.indexOf('text/') === 0) {
          var reader = new FileReader();
          reader.onload = function () {
            t.toast('まだ公開されていません');
          };
          reader.readAsText(blob);
          return;
        }
        var ok = kind === 'zip'
          ? ctype.indexOf('zip') !== -1
          : ctype.indexOf('pdf') !== -1;
        if (!ok) {
          t.toast('ダウンロードに失敗しました');
          return;
        }
        var name = kind === 'zip'
          ? ('settlement-' + t.year + '.zip')
          : (t.year + '-' + params.month + '.pdf');
        var objectUrl = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = name;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function () {
          window.URL.revokeObjectURL(objectUrl);
        }, 1000);
        t.toast('ダウンロードが完了しました');
      }).catch(function () {
        t.toast('ダウンロードに失敗しました');
      });
    },
    onDownloadCurrent: function () {
      if (this.pdfBusy) return;
      if (!this.published) {
        this.toast('まだ公開されていません');
        return;
      }
      var el = this.$el.querySelector('.owner-settlement-sheet-inner');
      if (!el) {
        this.toast('ダウンロードに失敗しました');
        return;
      }
      var t = this;
      var sheet = this.$el.querySelector('.owner-settlement-sheet');
      var prevScroll = sheet ? sheet.scrollTop : 0;
      var capture = null;
      if (sheet) sheet.scrollTop = 0;
      this.pdfBusy = true;
      var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
      fontsReady.then(function () {
        return import('html2canvas');
      }).then(function (mod) {
        var shoot = mod.default || mod;
        capture = mountPdfSheet(el);
        var scale = 2;
        if (capture.width * scale > 4096 || capture.height * scale > 8192) scale = 1;
        return shoot(capture.node, {
          backgroundColor: '#e6e6e5',
          scale: scale,
          useCORS: true,
          logging: false,
          width: capture.width,
          height: capture.height,
          windowWidth: capture.width,
          windowHeight: Math.max(capture.height, window.innerHeight || 0)
        });
      }).then(function (canvas) {
        return canvasToJpegPdf(canvas, capture.width, capture.height);
      }).then(function (bytes) {
        savePdfBytes(bytes, t.year + '年' + t.month + '月精算金計算書.pdf');
        t.toast('ダウンロードが完了しました');
      }).catch(function () {
        t.toast('ダウンロードに失敗しました');
      }).then(function () {
        t.pdfBusy = false;
        if (capture && capture.host && capture.host.parentNode) capture.host.parentNode.removeChild(capture.host);
        if (sheet) sheet.scrollTop = prevScroll;
      });
    },
    onPrintAnnual: function () {
      var t = this;
      axios.get('landlord/settlement/annualPdf', {
        params: { year: this.year }
      }).then(function (res) {
        var html = res.data && res.data.options && res.data.options.html;
        if (res.data && res.data.status == 1 && html) {
          t.printHtml(html);
          return;
        }
        t.toast('まだ公開されていません');
      }).catch(function () {
        t.toast('読み込みに失敗しました');
      });
    },
    onDownloadPack: function () {
      var months = (this.pickedMonths || []).map(function (m) {
        return Number(m);
      }).filter(function (m) {
        return m >= 1 && m <= 12;
      }).sort(function (a, b) {
        return a - b;
      });
      if (!months.length) {
        this.toast('月を選択してください');
        return;
      }
      if (months.length === 1) {
        this.downloadBlob('landlord/settlement/file', { year: this.year, month: months[0] }, 'pdf');
        return;
      }
      this.downloadBlob('landlord/settlement/zip', {
        year: this.year,
        months: months.join(',')
      }, 'zip');
    },
    applyMockSheet: function () {
      var o = '〇';
      var marks = [];
      var mi;
      for (mi = 0; mi < STAY_COLS.length; mi++) marks.push(o);
      var sample = '';
      for (mi = 0; mi < 24; mi++) sample += 'サンプルテキスト';
      sample += '|';
      var stayA = {
        checkin: '2025-01-01',
        checkout: '2025-01-03',
        days: '3',
        guests: '1',
        income: '10,000,000',
        tax: '-' + o,
        A: '-' + o,
        B: '-' + o,
        C: '-' + o,
        D: '-' + o,
        E: '-' + o,
        F: '-' + o,
        G: '-' + o,
        H: '-' + o,
        ownerIncome: '1,000,000'
      };
      var stayB = {
        checkin: o,
        checkout: o,
        days: '1',
        guests: '6',
        income: o,
        tax: o,
        A: o,
        B: '-' + o,
        C: o,
        D: o,
        E: o,
        F: o,
        G: o,
        H: o,
        ownerIncome: '1,000,000'
      };
      var filler = { checkout: o, days: o, guests: o, income: o };
      var room = function (id) {
        return {
          id: id,
          name: '○○邸',
          feeDisplay: { I: '789456', J: '46856', K: '564231' },
          filler: filler,
          marks: marks.slice(),
          stays: [stayA, stayB]
        };
      };
      var months = [];
      for (mi = 0; mi < 12; mi++) months.push({ profit: o, adr: o, occ: o });
      var monthRoom = function (id) {
        return { id: id, name: '〇〇邸', months: months };
      };
      this.mockHold = true;
      this.loadSeq += 1;
      this.year = 2025;
      this.month = 6;
      this.published = true;
      this.publishedList = [{ year: 2025, month: 6 }];
      this.meta.guestName = '〇〇〇〇〇〇〇〇〇〇〇〇〇〇';
      this.meta.period = '20○○年〇月';
      this.meta.contractRate = '売上高22％契約';
      this.meta.reportNote = '報告：毎月15日まで末締め翌末支払い';
      this.meta.bankName = '〇〇信用銀行';
      this.meta.bankBranch = '〇●支店';
      this.meta.accountType = '普通口座';
      this.meta.accountNo = '114514';
      this.meta.accountName = '○〇太郎';
      this.meta.accountId = 'T516145656879946';
      this.meta.comment = sample;
      this.meta.company = '京蘭アセットマネージメント株式会社';
      this.meta.companyZip = '〒600-8198';
      this.meta.companyReg = '登録番号：T3130001076569';
      this.meta.companyAddress = '京都府京都市下京区若松町433-1';
      this.rows = [room(1), room(2)];
      this.yearRows = [monthRoom(1), monthRoom(2), monthRoom(3)];
      this.transferRow = { id: 'pay', name: '振込金額', profit: '', adr: o, occ: '' };
      this.ijk = {
        b: o, c: o, d: o, e: o, f: o, g: o, h: o,
        i: o, j: o, k: o, taxed: o, taxIn: o, taxOut: o, taxRate: '10％'
      };
      this.items = [];
    },
    clearMockSheet: function () {
      this.mockHold = false;
      this.load();
    },
    load: function () {
      if (this.mockHold) return;
      this.transferRow = null;
      var t = this;
      this.loadSeq += 1;
      var seq = this.loadSeq;
      this.loadPublished();
      this.annualCache = null;
      this.yearRows = [];
      var guestName = this.meta.guestName;
      this.meta = this.blankMeta(this.year, this.month);
      this.meta.guestName = guestName;
      axios.get('landlord/settlement', {
        params: { year: this.year, month: this.month }
      }).then(function (res) {
        if (seq !== t.loadSeq) return;
        var opt = res.data && res.data.options;
        if (res.data && res.data.status == 1 && opt && opt.settlement && opt.settlement.status === 'published') {
          t.applyPublished(opt);
        } else {
          t.published = false;
          t.items = [];
          t.rows = [];
          t.yearRows = [];
          t.rowsStamp = '';
          t.ijk = t.blankIjk();
        }
      }).catch(function () {
        if (seq !== t.loadSeq) return;
        t.published = false;
        t.rows = [];
        t.yearRows = [];
        t.rowsStamp = '';
      });
      axios.get('landlord/settlement/annual', {
        params: { year: this.year }
      }).then(function (res) {
        if (seq !== t.loadSeq) return;
        if (res.data && res.data.status == 1 && res.data.options) {
          t.applyAnnual(res.data.options);
        }
      }).catch(function () {});
    },
    printHtml: function (html) {
      var w = window.open('', '_blank');
      if (!w) return false;
      w.document.open();
      w.document.write(html);
      w.document.close();
      w.focus();
      w.print();
      return true;
    },
    onPrint: function () {
      if (!this.published) {
        if (window.A && A.toast) A.toast('まだ公開されていません');
        return;
      }
      var t = this;
      axios.get('landlord/settlement/pdf', {
        params: { year: this.year, month: this.month }
      }).then(function (res) {
        var html = res.data && res.data.options && res.data.options.html;
        if (res.data && res.data.status == 1 && html) {
          t.printHtml(html);
          return;
        }
        if (!html) window.print();
      }).catch(function () {
        window.print();
      });
    }
  }
};
